/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest,
  TelegramProductsUserControllerEnqueueDescriptionGenerationMutationResponse,
  TelegramProductsUserControllerEnqueueDescriptionGeneration401,
} from '../../types/TelegramProductsUserControllerEnqueueDescriptionGeneration.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserEnqueueDescriptionGeneration } from '../../methods/telegramProductsUserEnqueueDescriptionGeneration.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserEnqueueDescriptionGenerationMutationKey = () =>
  [{ url: '/api/user/telegram/products/description-generation/queue' }] as const;

export type TelegramProductsUserEnqueueDescriptionGenerationMutationKey = ReturnType<
  typeof telegramProductsUserEnqueueDescriptionGenerationMutationKey
>;

/**
 * {@link /api/user/telegram/products/description-generation/queue}
 */
export function useTelegramProductsUserEnqueueDescriptionGeneration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerEnqueueDescriptionGenerationMutationResponse,
      ResponseErrorConfig<TelegramProductsUserControllerEnqueueDescriptionGeneration401>,
      { data: TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserEnqueueDescriptionGenerationMutationKey();

  return useMutation<
    TelegramProductsUserControllerEnqueueDescriptionGenerationMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerEnqueueDescriptionGeneration401>,
    { data: TelegramProductsUserControllerEnqueueDescriptionGenerationMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramProductsUserEnqueueDescriptionGeneration(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
